<template>
  <div class="dataBoaedPage">
    <Tabs :activeCom.sync="activeCom" :tabs="tabs" @handleTabs="handleTabs" />
    <div class="bottomContent">
      <component :is="activeCom" />
    </div>
  </div>
</template>

<script>
import Tabs from './components/Tabs.vue';
import RealSituation from './deviceReal/RealSituation.vue';
import DataAnalysis from './dataAnalysis/DataAnalysis.vue';
import { TempUtils } from '@/utils/TempUtil.js';

export default {

  components: {
    Tabs,
    DataAnalysis,
    RealSituation
  },
  data() {
    return {
      tabs: [
        {
          label: $t('integration.real_time_situation'),
          name: 'RealSituation'
        },
        {
          label: $t('integration.data_analysis'),
          name: 'DataAnalysis'
        }
      ],
      activeCom: 'RealSituation',
    }
  },
  created() {
  },
  methods: {
    handleTabs({ name }) {
    }

  }
}
</script>

<style lang="scss" scoped>
.dataBoaedPage {
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.bottomContent {
  height: calc(100% - 56px);
  // display: flex;
}
</style>
